// extracted by mini-css-extract-plugin
export var cardLayout = "_78-1";
export var paginationContainer = "_78-0";